import { Layout } from "@/components/layout/Layout";
import { Seo } from "@/components/seo/Seo";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { LeadForm } from "@/components/LeadForm";
import { Phone, Mail, MapPin, Clock, ShieldCheck } from "lucide-react";
import { BRAND } from "@/data/site";
import { breadcrumbSchema, orgSchema } from "@/lib/schema";

const Contact = () => (
  <Layout>
    <Seo
      title="Contact VRP Flooring LLC | Free Flooring Estimate in Danbury, CT"
      description="Request a free, no-obligation flooring estimate in Danbury, CT and Fairfield County. Call (203) 617-7324 or send us your project details — same-day appointments available."
      jsonLd={[orgSchema(), breadcrumbSchema([{ name: "Home", url: BRAND.website }, { name: "Contact", url: `${BRAND.website}/contact` }])]}
    />
    <section className="container-page py-12 md:py-16">
      <Breadcrumbs items={[{ name: "Home", href: "/" }, { name: "Contact" }]} />
      <div className="mt-6 grid lg:grid-cols-2 gap-12">
        <div>
          <p className="eyebrow mb-4 text-accentInk">Free Estimate</p>
          <h1 className="font-display text-4xl md:text-5xl font-bold mb-5">Let's plan your new floors.</h1>
          <p className="text-muted-foreground text-lg mb-8">Tell us about your space and we'll bring the samples to you. Most estimates are scheduled the same day, with installation available as soon as the next day.</p>
          <ul className="space-y-4 mb-8">
            <li className="flex items-start gap-3"><Phone className="h-5 w-5 text-accent mt-1" /><div><div className="font-semibold">Phone</div><a href={`tel:${BRAND.phone.replace(/\s/g, "")}`} className="text-muted-foreground hover:text-accent">{BRAND.phoneDisplay}</a></div></li>
            <li className="flex items-start gap-3"><Mail className="h-5 w-5 text-accent mt-1" /><div><div className="font-semibold">Email</div><a href={`mailto:${BRAND.email}`} className="text-muted-foreground hover:text-accent break-all">{BRAND.email}</a></div></li>
            <li className="flex items-start gap-3"><MapPin className="h-5 w-5 text-accent mt-1" /><div><div className="font-semibold">Address</div><div className="text-muted-foreground">{BRAND.address.street}, {BRAND.address.city}, {BRAND.address.region} {BRAND.address.postalCode}</div></div></li>
            <li className="flex items-start gap-3"><Clock className="h-5 w-5 text-accent mt-1" /><div><div className="font-semibold">Hours</div>{BRAND.hours.map((h) => <div key={h.day} className="text-muted-foreground text-sm">{h.day}: {h.time}</div>)}</div></li>
            <li className="flex items-start gap-3"><ShieldCheck className="h-5 w-5 text-trust mt-1" /><div><div className="font-semibold">Licensed &amp; Insured</div><div className="text-muted-foreground text-sm">Locally owned and operated flooring contractor</div></div></li>
          </ul>
        </div>
        <div>
          <LeadForm />
        </div>
      </div>
    </section>
  </Layout>
);
export default Contact;
